import { HttpMethod } from '@nu-art/thunderstorm-shared';
import { DBDef_AdvisorSnippet } from './db-def.js';
export const ApiDef_AdvisorSnippet = {
    _v1: {
        updateFHIRQueryResources: { method: HttpMethod.POST, path: `/v1/${DBDef_AdvisorSnippet.dbKey}/update-fhir-query-resources` },
    }
};
//# sourceMappingURL=api-def.js.map